module.exports = __webpack_public_path__ + "img/Methodical Organiser.4d089cfe.svg";